export default __webpack_public_path__ + "static/media/arrow-rounded-right-6x9.14e08239.svg";